/* unplugin-vue-components disabled */import { render } from "./phoneInput.vue?vue&type=template&id=943f849c"
import script from "./phoneInput.vue?vue&type=script&lang=js"
export * from "./phoneInput.vue?vue&type=script&lang=js"

import "./phoneInput.vue?vue&type=style&index=0&id=943f849c&lang=less"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__